import { cameraBannerProduct, carTracking1, enterpriseKit1, peopleTracking1, starterKit1 } from '@assets/images/main/camera';
import {
  productCardBleStarterM,
  productCardBleStarterD,
  productCardBleEnterpriseM,
  productCardBleEnterpriseD,
  productCardAoaStarterM,
  productCardAoaStarterD,
  productCardAoaEnterpriseM,
  productCardAoaEnterpriseD,
  productCardUwbStarterM,
  productCardUwbStarterD,
  productCardUwbEnterpriseM,
  productCardUwbEnterpriseD,
  productCardComfortM,
  productCardComfortD,
  productCardAiStarterM,
  productCardAiStarterD,
  productCardAiServerM,
  productCardAiServerD,
  productCardVehicleM,
  productCardVehicleD,
  productCardYardM,
  productCardYardD,
  productCardCameraM,
  productCardCameraD,
  productCardOutdoorM,
  productCardOutdoorD,
  productCardRtlsM,
  productCardRtlsD,
  productCardAccessM,
  productCardAccessD,
  productCardIotM,
  productCardIotD,
  productCardOrbroOsM,
} from '@assets/images/main/home/products/all';

import {
  aoaEnterpriseKit,
  aoaStarterKit,
  assetTracking1,
  bleEnterpriseKit,
  bleStarterKit,
  comfortKit1,
  uwbEnterpriseKit,
  uwbStarterKit,
  workerTracking1,
} from '@assets/images/main/rtls/product';
import { iotBannerProduct } from '@assets/images/main/sensor';

export default {
  assetPackage: {
    label: '資産位置測位パッケージ',
    title: '資産位置測位パッケージ',
    product: 'TwinTracker 10 + Server1',
    desc: 'BLEデバイスを作業者や機器に取り付けてリアルタイムで位置を測位する製品です。',
    img: assetTracking1,
    link: '/jp/rtls',
    index: '1',
  },

  workerPackage: {
    label: '作業者位置測位パッケージ',
    title: '作業者位置測位パッケージ',
    product: 'TwinTrackerPro 10 + Server1',
    desc: 'UWBデバイスを作業者や機器に取り付けてリアルタイムで位置を測位する製品です。',
    img: workerTracking1,
    link: '/jp/rtls',
    index: '2',
  },

  carPackage: {
    label: '車両位置測位パッケージ',
    title: '車両位置測位パッケージ',
    product: 'Server1 1 + NVR 1 + PTZ Camera2',
    desc: 'カメラを使用して人、車両などさまざまなオブジェクトの位置と異常な動きを検知し、管理することができます。',
    img: carTracking1,
    link: '/jp/camera',
    index: '1',
  },
  peoplePackage: {
    label: 'People Tracking and Analysis パッケージ',
    title: '流動人口分析パッケージ',
    product: 'Server1 + NVR1 + IP Camera4',
    desc: 'このカメラは、室内の人々の移動経路を分析し、予期せぬ状況を感知することができます。',
    img: peopleTracking1,
    link: '/camera',
    index: '2',
  },

  recommand: '推奨製品',

  cards: [
    {
      title: 'TwinTracker BLE スターターキット',
      desc: 'ORBRO Edge RTLS、L2スイッチ、TwinTracker BLE（4台）',
      link: '/rtls/ble',
      img: { desktop: productCardBleStarterD, tablet: productCardBleStarterM, mobile: productCardBleStarterM },
    },
    {
      title: 'BLE エンタープライズキット',
      desc: 'ORBROサーバー、L2スイッチ（2台）、ORBRO Edge RTLS（2台）、TwinTracker BLE（12台）',
      link: '/rtls/ble',
      img: { desktop: productCardBleEnterpriseD, tablet: productCardBleEnterpriseM, mobile: productCardBleEnterpriseM },
    },
    {
      title: 'TwinTracker AoA スターターキット',
      desc: 'ORBRO Edge RTLS、L2スイッチ、TwinTracker AoA（4台）',
      link: '/rtls/aoa',
      img: { desktop: productCardAoaStarterD, tablet: productCardAoaStarterM, mobile: productCardAoaStarterM },
    },
    {
      title: 'AoA エンタープライズキット',
      desc: 'ORBROサーバー、L2スイッチ（2台）、ORBRO Edge RTLS（2台）、TwinTracker AoA（12台）',
      link: '/rtls/aoa',
      img: { desktop: productCardAoaEnterpriseD, tablet: productCardAoaEnterpriseM, mobile: productCardAoaEnterpriseM },
    },
    {
      title: 'TwinTracker UWB スターターキット',
      desc: 'ORBROサーバー、L2スイッチ（2台）、ORBRO Edge RTLS（2台）、TwinTracker BLE（12台）',
      link: '/rtls/uwb',
      img: { desktop: productCardUwbStarterD, tablet: productCardUwbStarterM, mobile: productCardUwbStarterM },
    },
    {
      title: 'UWB エンタープライズキット',
      desc: 'ORBROサーバー、L2スイッチ（2台）、ORBRO Edge RTLS（2台）、TwinTracker UWB（12台）',
      link: '/rtls/uwb',
      img: { desktop: productCardUwbEnterpriseD, tablet: productCardUwbEnterpriseM, mobile: productCardUwbEnterpriseM },
    },
    {
      title: 'Comfort キット',
      desc: 'モバイルアプリ、UWBタグ（8個）、UWBタグ',
      link: '/rtls/comfort',
      img: { desktop: productCardComfortD, tablet: productCardComfortM, mobile: productCardComfortM },
    },
    {
      title: 'ORBRO Edge AI スターターキット',
      desc: 'ORBRO Edge AI、L2スイッチ',
      link: '/camera/edge',
      img: { desktop: productCardAiStarterD, tablet: productCardAiStarterM, mobile: productCardAiStarterM },
    },
    {
      title: 'ORBRO AI サーバー エンタープライズキット',
      desc: 'ORBRO AI サーバー、ORBRO サーバー',
      link: '/camera/server',
      img: { desktop: productCardAiServerD, tablet: productCardAiServerM, mobile: productCardAiServerM },
    },
    {
      title: '車両追跡キット',
      desc: 'ORBROサーバー x 1 + GPSデバイス x 5',
      link: '/outdoor/gps',
      img: { desktop: productCardVehicleD, tablet: productCardVehicleM, mobile: productCardVehicleM },
    },
    {
      title: 'ヤード追跡キット',
      desc: 'ORBROサーバー、LoRaゲートウェイ、GPSタグ（10個）',
      link: '/outdoor/lora',
      img: { desktop: productCardYardD, tablet: productCardYardM, mobile: productCardYardM },
    },
    {
      title: '映像位置追跡',
      desc: 'AIベースの映像によるオブジェクト追跡',
      link: '/camera',
      img: { desktop: productCardCameraD, tablet: productCardCameraM, mobile: productCardCameraM },
    },
    {
      title: '屋外位置追跡',
      desc: '車両およびヤード位置追跡',
      link: '/outdoor',
      img: { desktop: productCardOutdoorD, tablet: productCardOutdoorM, mobile: productCardOutdoorM },
    },
    {
      title: '無線位置追跡',
      desc: 'BLE、AoA、UWBなどの無線通信ベースの位置追跡',
      link: '/rtls',
      img: { desktop: productCardRtlsD, tablet: productCardRtlsM, mobile: productCardRtlsM },
    },
    {
      title: '入退室システム',
      desc: '自動ドア、顔認証などのアクセス制御',
      link: '/access',
      img: { desktop: productCardAccessD, tablet: productCardAccessM, mobile: productCardAccessM },
    },
    {
      title: 'Industry IoT',
      desc: '空気質・一酸化炭素センサー、LoRaゲートウェイ、ロボットとの連携',
      link: '/iot',
      img: { desktop: productCardIotD, tablet: productCardIotM, mobile: productCardIotM },
    },
    {
      type: 'orbroOs',
      title: 'ORBRO OS',
      desc: 'All Spaces, All Devices, Connected at a Glance on a Digital Platform',
      link: '/os',
      img: {
        desktop: productCardOrbroOsM,
        tablet: productCardOrbroOsM,
        mobile: productCardOrbroOsM,
      },
    },
  ],
};
